import { Alert, Button } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";

interface BrandStagesErrorBannerProps {
  message: string;
  onRetry: () => void;
}

// Inline banner above a chart whose Lead Funnel request(s) failed (spec
// Section 3.6) - the rest of the tab keeps rendering what did load.
export default function BrandStagesErrorBanner({ message, onRetry }: BrandStagesErrorBannerProps) {
  return (
    <Alert
      severity="error"
      variant="outlined"
      sx={{ mb: 1.75, alignItems: "center" }}
      action={
        <Button color="inherit" size="small" startIcon={<ReplayIcon />} onClick={onRetry}>
          Retry
        </Button>
      }
    >
      {message}
    </Alert>
  );
}
